import React, { useState } from "react";

export default function MessageQueue() {
  const [showDialog, setShowDialog] = useState(false);

  // Sample empty data for now
  const messages = [];

  const handleActionClick = () => setShowDialog(true);
  const handleCloseDialog = () => setShowDialog(false);

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      {/* Title */}
      <h1 className="text-xl font-semibold text-gray-800 mb-4">Message Queue</h1>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
        <input
          type="text"
          placeholder="Search"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <input
          type="text"
          placeholder="Start date (dd/mm/yyyy)"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <input
          type="text"
          placeholder="End date (dd/mm/yyyy)"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <input
          type="text"
          placeholder="From address"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <input
          type="text"
          placeholder="To address"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />

        <div className="flex items-center space-x-2">
          <input type="checkbox" id="notSent" className="w-4 h-4" />
          <label htmlFor="notSent" className="text-sm text-gray-700">
            Load not sent emails only
          </label>
        </div>

        <div>
          <label className="text-sm text-gray-700 block mb-1">
            Maximum send attempts
          </label>
          <input
            type="number"
            defaultValue="10"
            className="border rounded-lg px-3 py-2 text-sm w-full"
          />
        </div>

        <div>
          <label className="text-sm text-gray-700 block mb-1">
            Go directly to email #
          </label>
          <input
            type="number"
            defaultValue="0"
            className="border rounded-lg px-3 py-2 text-sm w-full"
          />
        </div>
      </div>

      {/* Learn More */}
      <a
        href="#"
        className="text-blue-600 text-sm hover:underline mb-4 inline-block"
      >
        Learn more about message queue
      </a>

      {/* Right side buttons */}
      <div className="flex flex-wrap justify-end gap-2 mb-4">
        <button
          onClick={handleActionClick}
          className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-lg"
        >
          Request Selected
        </button>
        <button
          onClick={handleActionClick}
          className="bg-yellow-500 hover:bg-yellow-600 text-white text-sm px-4 py-2 rounded-lg"
        >
          Delete Selected
        </button>
        <button
          onClick={handleActionClick}
          className="bg-red-600 hover:bg-red-700 text-white text-sm px-4 py-2 rounded-lg"
        >
          Delete All
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">ID</th>
              <th className="py-3 px-4 font-medium">Subject</th>
              <th className="py-3 px-4 font-medium">From</th>
              <th className="py-3 px-4 font-medium">To</th>
              <th className="py-3 px-4 font-medium">Created On</th>
              <th className="py-3 px-4 font-medium">Planned Date</th>
              <th className="py-3 px-4 font-medium">Sent On</th>
              <th className="py-3 px-4 font-medium">Priority</th>
              <th className="py-3 px-4 font-medium">Edit</th>
            </tr>
          </thead>
          <tbody>
            {messages.length === 0 ? (
              <tr>
                <td
                  colSpan="9"
                  className="text-center py-6 text-gray-500 italic"
                >
                  No data available in table
                </td>
              </tr>
            ) : (
              messages.map((msg, i) => (
                <tr key={i} className="border-t hover:bg-gray-50">
                  <td className="py-3 px-4">{msg.id}</td>
                  <td className="py-3 px-4">{msg.subject}</td>
                  <td className="py-3 px-4">{msg.from}</td>
                  <td className="py-3 px-4">{msg.to}</td>
                  <td className="py-3 px-4">{msg.createdOn}</td>
                  <td className="py-3 px-4">{msg.plannedDate}</td>
                  <td className="py-3 px-4">{msg.sentOn}</td>
                  <td className="py-3 px-4">{msg.priority}</td>
                  <td className="py-3 px-4">
                    <button className="text-blue-600 hover:underline">
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Previous
          </button>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Next
          </button>
        </div>

        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>

        <p>No records</p>
      </div>

      {/* Confirmation Dialog */}
      {showDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6">
            <div className="flex justify-between items-center mb-3">
              <h2 className="text-lg font-semibold text-gray-800">
                Are you sure?
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700 text-xl"
                onClick={handleCloseDialog}
              >
                ×
              </button>
            </div>
            <p className="text-gray-600 mb-6">
              Are you sure you want to perform this action?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={handleCloseDialog}
                className="px-4 py-2 border rounded-lg hover:bg-gray-100 text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleCloseDialog}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
